export default __webpack_public_path__ + "static/media/course1.9c20dde4.jpg";